import { render, staticRenderFns } from "./handItems.vue?vue&type=template&id=5867697e&scoped=true"
import script from "./handItems.vue?vue&type=script&lang=js"
export * from "./handItems.vue?vue&type=script&lang=js"
import style0 from "./handItems.vue?vue&type=style&index=0&id=5867697e&prod&lang=scss&scoped=true"
import style1 from "./handItems.vue?vue&type=style&index=1&id=5867697e&prod&scoped=true&lang=css"
import style2 from "./handItems.vue?vue&type=style&index=2&id=5867697e&prod&lang=scss&scoped=true"
import style3 from "./handItems.vue?vue&type=style&index=3&id=5867697e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5867697e",
  null
  
)

export default component.exports